import { useCallback } from 'react';
import useAccountPicker from 'features/invest/hooks/useAccountPicker';
import Amplitude from 'utils/amplitude';
import { useDefaultBankAccount } from './accounts';
export const useDefaultAccountPicker = () => {
    const picker = useAccountPicker();
    const openPicker = useCallback(async (accounts, params) => picker(accounts, {
        emptyText: 'No accounts to choose from.',
        title: 'Select your pay account',
        subTitle: 'This will be used to send and receive money.',
        disableNonPISP: true,
        ...params,
    }), [picker]);
    const [defaultAccount, , , , setAccount] = useDefaultBankAccount();
    const openPickerIfNoDefaultAccountSet = useCallback(async () => {
        if (defaultAccount) {
            return defaultAccount;
        }
        try {
            const result = (await openPicker(undefined, {
                emptyText: undefined,
            }));
            Amplitude.logEvent('Set Default Payment', {
                prevAccountId: null,
                prevBankId: null,
                accountId: result?.id ?? null,
                bankId: result?.bankId ?? null,
                onboarding: false,
            });
            setAccount(result);
            return result;
        }
        catch {
            // noop
            return undefined;
        }
    }, [defaultAccount, openPicker, setAccount]);
    return [openPicker, openPickerIfNoDefaultAccountSet];
};
